module.exports = __webpack_public_path__ + "img/moco.3fe145e4.jpg";